<div class="row">
  <div class="col">
    <h5>Available Competencies</h5>
    <p class="text-muted">Select the key Competencies that are essential for this role. If you have any questions, contact us at
      <a href="mailto:testing@ccoleadership.com">testing&#64;ccoleadership.com</a>.
    </p>
    @if (competencyPdfUrl) {
      <p class="text-muted">
        Download the full list <a [href]="competencyPdfUrl" target="_blank" rel="noopener">Here</a>.
      </p>
    }
    <div class="view-select" style="margin-bottom: 15px;">
      View:&nbsp;
      <div class="form-check-inline">
        <label class="form-check-label form-control-label">
          <input class="form-check-input" type="radio" name="showAvailableAsList" [value]="false"
            [(ngModel)]="showAvailableAsList" (ngModelChange)="onListTypeChange()">
            Hierarchy
          </label>
        </div>
        <div class="form-check-inline">
          <label class="form-check-label form-control-label">
            <input class="form-check-input" type="radio" name="showAvailableAsList" [value]="true"
              [(ngModel)]="showAvailableAsList" (ngModelChange)="onListTypeChange()">
              List
            </label>
          </div>
        </div>
        <quick-filter-input (onChanged)="competencyFilterChange($event)"></quick-filter-input>
      </div>
      <div class="col">
        <h5>Assigned Competencies</h5>
        <p class="text-muted">Click a competency below to to deselect it.</p>
        <p>{{assignedCompetencies.length}} of {{maxAssignedCompetenciesAllowed}} Competencies Selected</p>
        <quick-filter-input (onChanged)="assignFilterChange($event)"></quick-filter-input>
      </div>
    </div>
    <div class="row">
      <div class="col">
        @if (!showAvailableAsList) {
          <competency-hierarchy (onCompetencyClicked)="competencyClicked($event, true)"
            [clientCompetencies]="availableCompetencies" [competencyIdsToExclude]="assignedIds">
          </competency-hierarchy>
        }
        @if (showAvailableAsList) {
          <competency-list [iconSide]="'right'" [scrollSize]="'md'" [competencies]="filteredAvailableCompetencies"
            [iconClasses]="['fa', 'fa-chevron-right']" (onCompetencyClicked)="competencyClicked($event, true)">
          </competency-list>
        }
      </div>
      <div class="col">
        @if (assignedCompetencies && assignedCompetencies.length) {
          <competency-list [(competencies)]="filteredSelectedCompetencies"
            [iconClasses]="['fa', 'fa-chevron-left']"
            (onCompetencyClicked)="competencyClicked($event, false)">
          </competency-list>
        }
        @if (!assignedCompetencies || !assignedCompetencies.length) {
          <div>No competencies assigned.</div>
        }
      </div>
    </div>
